import * as z from 'zod'

import {
  optionalText,
  ownershipFields,
  requiredAmount,
  requiredDate,
  requiredText,
  tagList,
  withOwnership,
} from '../utils/schema'

export const loanSchema = withOwnership(z.object({
  ...ownershipFields(),
  assetName: requiredText('Name this loan'),
  /* Fixed by the flow, not collected — see LIABILITY_TYPE in ./index.ts. */
  assetType: z.literal('loan'),
  description: optionalText(),
  amount: requiredAmount('Enter the amount of the loan'),
  date: requiredDate('Enter the date the loan was taken'),
  currency: optionalText(),
  tags: tagList(),
}))

export type LoanValues = z.infer<typeof loanSchema>
